/**
 * @file    SectionHeader.js
 * @author  Daniel Naftzger
 * @created 2026-02-26
 * @updated 2026-02-26
 *
 * @description
 * Reusable header component rendered at the top of each main content section.
 * Displays a numbered label and a title separated by a horizontal rule.
 */
import styles from '../styles';

/**
 * Renders a section header with a numbered label and title.
 *
 * @param {Object} props
 * @param {string} props.label - The section number displayed before the title (e.g. "02")
 * @param {string} props.title - The section heading text (e.g. "Projects")
 * @returns {JSX.Element}
 */
function SectionHeader({ label, title }) {
  return (
    <div style={styles.sectionHeader}>
      <span style={styles.sectionLabel}>{label} —</span>
      <h2 style={styles.sectionTitle}>{title}</h2>
    </div>
  );
}

export default SectionHeader;
